import { NavLink, Outlet } from 'react-router-dom';

import { routePaths } from '@/app/router/routePaths';
import { cn } from '@/shared/utils/cn';

const ADMIN_LINKS = [
  { to: routePaths.admin.root, label: 'Steuerung', end: true },
  { to: routePaths.admin.teams, label: 'Teams', end: false },
  { to: routePaths.admin.matches, label: 'Spiele & Boards', end: false },
  { to: routePaths.admin.conflicts, label: 'Konflikte', end: false },
  { to: routePaths.admin.settings, label: 'Einstellungen', end: false },
] as const;

/**
 * Shell for the tournament director's area, with its own sub-navigation. The
 * route is already gated by RequireAdmin, so this layout assumes admin access.
 */
export function AdminLayout() {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <p className="text-brand text-xs font-semibold tracking-widest uppercase">Turnierleitung</p>
        <nav aria-label="Adminbereich" className="border-line -mx-1 border-b">
          <ul className="flex gap-1 overflow-x-auto px-1">
            {ADMIN_LINKS.map((link) => (
              <li key={link.to}>
                <NavLink
                  to={link.to}
                  end={link.end}
                  className={({ isActive }) =>
                    cn(
                      'touch-target inline-block px-3 py-3 text-sm whitespace-nowrap transition-colors',
                      isActive
                        ? 'border-brand text-fg border-b-2 font-semibold'
                        : 'text-fg-muted hover:text-fg border-b-2 border-transparent',
                    )
                  }
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
